import { ax } from "../utils/axios/axios";
import { BASE_API_URL } from "../constants";

interface Options {
  viewId: number;
  viewName: string;
  selectedItems: string;
  sharedUserSearialId: string;
  isDefault: boolean;
  userSearialId: number;
}
export const apiUserShiftCardViewUpdate = ({
  viewId,
  viewName,
  selectedItems,
  sharedUserSearialId,
  isDefault,
  userSearialId
}: Options) => {
  const data = {
    viewId,
    viewName,
    selectedItems,
    sharedUserSearialId,
    isDefault,
	userSearialId
  };
  const options = {
    method: "PUT",
    url: `${BASE_API_URL}/ref/shiftcardviews`,
    data,
  };
  return ax(options);
};
